import { TableHeaderCell, DropdownItem } from 'common/components';
import ReactDatePicker from 'react-datepicker';
import { useState } from 'react';
import { SortDirection, SortField } from 'types/call.type';
import { DateRangeType } from '../../../AgenticWorkflowDetail.types';
import styles from '../CallsTable.module.scss';

type DateCellProps = {
    dateRangeType: DateRangeType;
    onSortChange: (field: SortField, newSortDirection: SortDirection) => void;
    sortField: SortField;
    sortDirection: SortDirection;
    handleDateRangeChange: (range: string) => void;
    setDateRange: (dateRange: [Date | null, Date | null]) => void;
};

const DATE_RANGE_OPTIONS = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'last7days', label: 'Last 7 Days' },
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'next30Days', label: 'Next 30 Days' },
    { value: 'custom', label: 'Custom Range' },
];

export const DateCell = ({
    setDateRange,
    dateRangeType,
    onSortChange,
    sortField,
    sortDirection,
    handleDateRangeChange,
}: DateCellProps) => {
    const [startDate, setStartDate] = useState<Date | null>(new Date());
    const [endDate, setEndDate] = useState<Date | null>(null);

    return (
        <TableHeaderCell
            label='Date'
            sort={{
                isSorted: sortField === 'callDate',
                direction: sortDirection,
                onSort: () => onSortChange('callDate', sortDirection === 'asc' ? 'desc' : 'asc'),
            }}
            filterContent={({ onClose }) => (
                <>
                    <div>
                        {DATE_RANGE_OPTIONS.map((option) => (
                            <DropdownItem
                                key={option.value}
                                label={option.label}
                                value={option.value}
                                isSelected={dateRangeType === option.value}
                                onClick={(value) => {
                                    handleDateRangeChange(value as string);
                                    if (value !== 'custom') {
                                        onClose();
                                    }
                                }}
                            />
                        ))}
                    </div>
                    {dateRangeType === 'custom' && (
                        <div className={styles.dateInputGroup}>
                            <ReactDatePicker
                                selectsRange
                                selected={startDate}
                                onChange={(dates: [Date | null, Date | null]) => {
                                    const [start, end] = dates;
                                    setStartDate(start);
                                    setEndDate(end ?? null);
                                    if (start && end) {
                                        setDateRange(dates);
                                        onClose();
                                    }
                                }}
                                startDate={startDate}
                                endDate={endDate}
                                dateFormat='MM/dd/yy'
                                inline
                            />
                        </div>
                    )}
                </>
            )}
            filterActive={dateRangeType !== 'today'}
            filterDropdownClassName='flex'
        />
    );
};
